<template>
  <div  class="details">
    <router-link :to="{ name: 'Home' }"
      ><button>
        <img v-if="darkMode" src="../assets/arrowb.svg" alt="" />
        <img v-else src="../assets/arrow.svg" alt="" />Back
      </button></router-link
    >
    <div v-if="info" class="detail-ctn">
      <img class="flag" :src="info.flag" alt="" />
    <div class="informations">
      <div class="flx">
        <div class="frst">
        <h3 @click="show">{{ pay }}</h3>
        <div><span>Native Name: </span>{{ info.name }}</div>
        <div><span>Population: </span>{{ info.population.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") }}</div>
        <div><span>Region: </span>{{ info.region }}</div>
        <div><span>Sub Region: </span>{{ info.subregion }}</div>
        <div><span>Capital: </span>{{ info.capital }}</div>
      </div>
      <div class="scnd">
        <div><span>Top Level Domain: </span>{{ info.topLevelDomain[0] }}</div>
        <div><span>Currencies: </span>{{ info.currencies[0].code }}</div>
        <div>
          <span>Languages: </span>
          <p v-for="lng in info.languages" :key="lng.name">
            {{ lng.name }}
          </p>
        </div>
      </div>
      </div>
      
      <div class="thrd" v-if="border">
        <h5 v-if="borders.length">Border Countries:</h5>
        <h5 v-else>No Border Countries</h5>
        <div class="brd">
          <router-link
            :to="{ name: 'dtails', params: { id: brd.name } }"
            v-for="brd in borders"
            :key="brd.name"
          >
            <button>{{ brd.name.split("(")[0] }}</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
  <spinner v-if="!info"/>
    </div>
    
</template>

<script>
import spinner from "@/components/spinner.vue";
export default {
  
  name:"dtails",
  props: ["darkMode"],
  components: {
    spinner
  },
  data() {
    return {
      pay: this.$route.params.id,
      info: false,
      border: [],
    };
  },
  computed: {
    borders() {
      this.info.borders.forEach((brd) => {
        fetch(`https://restcountries.eu/rest/v2/alpha/${brd}`)
          .then((resp) => resp.json())
          .then((resp) => this.border.push(resp));
      });

      return this.border;
    },
  },
  methods: {
    show() {
      console.log(this.borders);
    },
  },
  mounted() {
    fetch(`https://restcountries.eu/rest/v2/name/${this.pay}`)
      .then((resp) => resp.json())
      .then((resp) => (this.info = resp[0]))
      .catch((Error) => console.log(Error));
  },
};
</script>

<style>
</style>